AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Cat");

AoPS.Alcumus.Views.Cat = (function (AlcVCat) {
	// Dependencies
	var Rogb = AoPS.Rogb;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;

	// This file contains a few auxiliary views for dealing with an ill-defined
	// concept "categories", which are basically lists of subjects/classes/topics
	// and the associated hierarchy.
	// They are mainly used in the report but are borrowed by the focus changer.

	AlcVCat.Dropdown = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-cat-dropdown");

			this.exclude_all = options.exclude_all;
			this.is_tutorial = options.is_tutorial;

			this.render();
		},

		getValueFromModel: function (model) {
			if (!model) {
				return "all";
			} else if (model.model_type === "subject") {
				return "subject_" + model.id;
			} else if (model.model_type === "class") {
				return "class_" + model.id;
			} else {
				return "all";
			}
		},

		getModelFromValue: function (sel_val) {
			var val_id;

			if (sel_val === "all") {
				return this.model;
			} else if (sel_val.slice(0, 5) === "class") {
				val_id = parseInt(sel_val.slice(6), 10);
				return this.model.get("classes").get(val_id);
			} else if (sel_val.slice(0, 7) === "subject") {
				val_id = parseInt(sel_val.slice(8), 10);
				return this.model.get("subjects").get(val_id);
			}
		},

		selectModel: function (model) {
			this.$(".aops-select")
				.val(this.getValueFromModel(model))
				.trigger("chosen:updated");
		},

		onSelect: function (evt) {
			var sel_model = this.getModelFromValue(this.$(".aops-select").val());
			if (sel_model) {
				this.trigger("select", sel_model);
			}
		},

		getContext: function () {
			// Get ID and name out of the model
			function extract(model) {
				return {id: model.id, name: model.get("name")};
			}
			// Apply extract to each model of a collection, or return null if nothing.
			function extractAll(coll) {
				return coll.length ? coll.map(extract) : null;
			}

			return {
				exclude_all: this.exclude_all,
				is_tutorial: this.is_tutorial,
				subjects: extractAll(this.model.get("subjects")),
				classes: extractAll(this.model.get("classes")),
			};
		},

		postRender: function () {
			this.$(".aops-select").chosen({
				disable_search_threshold: 999,
				width: "200px",
				height: "28px",
			});
			this.$(".aops-select").on("change", _.bind(this.onSelect, this));
		},
	});

	// Pass parent_model containing all of the rows in the table and an array
	// of models to build rows from (row_models). Assumes the parent is loaded.
	// Also pass a table_type key, one of 'report_nav' or 'select', which
	// determines the effect of clicking table rows.
	AlcVCat.ProgressTable = AlcVBase.BaseView.extend({
		row_class_table: {
			// model_type: ViewClass name
			subject: "ProgressSubjectRow",
			class: "ProgressClassRow",
			topic: "ProgressTopicRow",
		},

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-progress-table");

			this.left_column_header = options.left_column_header || "Items";
			this.table_type = options.table_type;
			this.show_class_dates = !!options.show_class_dates;
			this.show_all_option = !!options.show_all_option;

			this.generateRows(options.parent_model, options.row_models || []);
			this.render();
		},

		selectModel: function (row_model) {
			if (!this.subview_table) {
				return;
			}
			var selected_cid = row_model ? row_model.cid : null;

			_.each(this.subview_table, function (view, model_cid) {
				view.setSelected && view.setSelected(model_cid === selected_cid);
			});
		},

		scrollToModel: function (row_model) {
			if (!row_model || !this.subview_table) {
				return;
			}

			var found_row = this.subview_table[row_model.cid];
			if (found_row) {
				this.$(".aops-scroll-inner").scrollTop(
					found_row.$el.position().top + 1
				);
			}
		},

		// Return null if no dates should be used or an array of the same length
		// as row_models. The corresponding element is a string if a date should
		// be displayed and null otherwise.
		getDateList: function (parent_model, row_models) {
			var curr_week = -1;
			var week_table = parent_model && parent_model.get("week_table");
			if (!this.show_class_dates || !week_table) {
				return null;
			}

			return _.map(row_models, function (topic) {
				var week_num = week_table[topic.id];
				if (curr_week < week_num) {
					curr_week = week_num;
					return parent_model.getWeekDate(week_num);
				}
				return null;
			});
		},

		generateRows: function (parent_model, row_models) {
			var location = ".alc--table-main tbody";
			this.clearLocation(location);
			this.stopListening();

			if (!row_models || !row_models.length) {
				return;
			}

			var date_list = this.getDateList(parent_model, row_models);
			this.has_date_col = !!date_list;

			this.subview_table = {};

			// Helper function for creating table rows
			var createRow = _.bind(function (ViewClass, model, date) {
				var params = {
					model: model,
					parent_model: parent_model,
					table_type: this.table_type,
				};
				if (date_list) {
					params.date = date;
				}

				var view_obj = new ViewClass(params);
				this.subview_table[model.cid] = view_obj;
				this.listenTo(view_obj, "select", this.onSelect);
				this.addSubviewToLocation(view_obj, location);
			}, this);

			// Make the main rows
			_.each(
				row_models,
				function (model, i) {
					var ViewClass = AlcVCat[this.row_class_table[model.model_type]];
					if (!ViewClass) {
						return;
					}
					createRow(ViewClass, model, date_list && date_list[i]);
				},
				this
			);

			// Make the all row, if applicable
			if (this.show_all_option) {
				createRow(AlcVCat.ProgressTopicRow, parent_model);
			}
		},

		onSelect: function (row_view) {
			// Note that for All Topics row, row_view.model will be undefined.
			this.selectModel(row_view.model);
			row_view.setSelected(true);
			this.trigger("select", row_view.model, row_view.parent_model);
		},

		getContext: function () {
			return {
				has_date_col: !!this.has_date_col,
				left_column_header: this.left_column_header,
			};
		},

		postRender: function () {
			AlcVBase.buildScrollbar(this.$el);
		},

		onClose: function () {
			AlcVBase.BaseView.prototype.onClose.apply(this);
		},
	});

	AlcVCat.ProgressSubjectRow = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-progress-subject-row");
			this.table_type = options.table_type;
			this.setupBarArray();
			this.render();
		},

		setupBarArray: function () {
			var bar_data = this.model.get("topics").map(function (topic) {
				return {
					status: topic.get("status"),
					percent: topic.get("progress"),
				};
			});
			var bar_array = new Rogb.BarArray({
				bar_data: bar_data,
				horiz: true,
			});
			this.addSubviewToLocation(bar_array, ".alc--bar-array-cell");
		},

		getUrl: function () {
			var model = this.model;
			if (this.table_type === "report_nav") {
				return AlcUrl.getUrl(
					"report_subject",
					model.get("user").getUrlId(),
					model.id
				);
			}
		},

		getContext: function () {
			var model = this.model;
			var url = this.getUrl();

			return {
				url: url,
				name: model.get("name"),
				level: model.get("level"),
				xp_to_next: model.get("xp_to_next"),
			};
		},

		postRender: function () {
			var url = this.getUrl();
			if (url) {
				this.$("td.alc--bar-cell")
					.addClass("alc-pointer")
					.click(function (evt) {
						Backbone.trigger("alc_goto_url", url);
					});
			}
		},
	});

	AlcVCat.ProgressClassRow = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-progress-class-row");
			this.table_type = options.table_type;
			this.setupBarArray();
			this.render();
		},

		setupBarArray: function () {
			var bar_data = this.model.get("topics").map(function (topic) {
				return {
					status: topic.get("status"),
					percent: topic.get("progress"),
				};
			});
			var bar_array = new Rogb.BarArray({
				bar_data: bar_data,
				horiz: true,
			});
			this.addSubviewToLocation(bar_array, ".alc--bar-array-cell");
		},

		getUrl: function () {
			var model = this.model;
			if (this.table_type === "report_nav") {
				return AlcUrl.getUrl(
					"report_class",
					model.get("user").getUrlId(),
					model.id
				);
			}
		},

		getContext: function () {
			var model = this.model;
			var url = this.getUrl();

			return {
				url: url,
				name: model.get("name"),
				level: model.get("level"),
				xp_to_next: model.get("xp_to_next"),
			};
		},

		postRender: function () {
			var url = this.getUrl();
			if (url) {
				this.$("td.alc--bar-cell")
					.addClass("alc-pointer")
					.click(function (evt) {
						Backbone.trigger("alc_goto_url", url);
					});
			}
		},
	});

	// If a non-topic model is passed, this class assumes this is an
	// "All topics" row in the Set Focus window.
	// A parent_model is always required.
	AlcVCat.ProgressTopicRow = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-progress-topic-row");

			this.parent_model = options.parent_model;
			this.selected = !!options.topic_selected;
			this.table_type = options.table_type;
			this.has_date_col = options.hasOwnProperty("date");
			this.date = options.date;
			this.is_all_row = this.model.model_type !== "topic";

			if (!this.is_all_row) {
				var progress_bar = new Rogb.TopicProgressBar({
					model: this.model,
					show_name: "none",
					show_percent: this.table_type === "report_nav",
				});
				this.addSubviewToLocation(progress_bar, "@progress_bar");
				var progress_marks = new Rogb.ProgressMarks();
				this.addSubviewToLocation(progress_marks, "@progress_marks");
			}

			this.render();
		},

		setSelected: function (new_val) {
			if (this.selected !== !!new_val) {
				this.selected = !!new_val;
				this.render();
			}
		},

		getUrl: function () {
			if (this.is_all_row || this.table_type !== "report_nav") {
				return;
			}

			var model = this.model;
			var parent_model = this.parent_model;
			var user_id = model.get("user").getUrlId();
			var url_type =
				parent_model.model_type === "class" ? "report_class" : "report_subject";

			if (this.selected) {
				// Topic is selected, so link to parent
				return AlcUrl.getUrl(url_type, user_id, parent_model.id);
			} else {
				return AlcUrl.getUrl(
					url_type + "_topic",
					user_id,
					parent_model.id,
					model.id
				);
			}
		},

		getContext: function () {
			if (this.is_all_row) {
				return {
					name: "All Topics in " + this.parent_model.get("name"),
					selected: this.selected,
					has_date_col: this.has_date_col,
					date: this.date,
				};
			}

			return {
				url: this.getUrl(),
				name: this.model.get("name"),
				selected: this.selected,
				has_date_col: this.has_date_col,
				date: this.date,
			};
		},

		postRender: function () {
			this.$el.toggleClass("alc--selected", !!this.selected);

			if (this.table_type === "select") {
				this.$el.addClass("alc-pointer");
				this.$el.click(
					_.bind(function () {
						this.trigger("select", this);
					}, this)
				);
			}

			var url = this.getUrl();
			if (url) {
				this.$("td.alc--bar-cell")
					.addClass("alc-pointer")
					.click(function (evt) {
						Backbone.trigger("alc_goto_url", url);
					});
			}
		},
	});

	return AlcVCat;
})(AoPS.Alcumus.Views.Cat);
